<div>
    <form [formGroup]="storeConsumptionForm">
        <div class="flex align-items-start pt20">
            <div *ngIf="!isEditModeComponent">
                <p-button label="Save" class="p-button-outlined ml-2 " icon="pi pi-save" size="small"
                    (click)="CreateStoreConsumption(storeConsumptionForm.value)"></p-button>
            </div>
            <div *ngIf="isEditModeComponent">
                <p-button label="Update" class="p-button-outlined ml-2 " icon="pi pi-save" size="small"
                    (click)="CreateStoreConsumption(storeConsumptionForm.value)"></p-button>
            </div>
            <div>
                <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                    size="small" (click)="cancel(storeConsumptionForm.value)"></p-button>
            </div>
        </div>
        <div class="grid padd">

            <div class="col">

                <div class="field text-left">
                    <label for="website">SCNumber</label>
                    <div class="flex align-items-center">
                        <input pInputText placeholder="e.g P307" type="text" (blur)="checkSCNumber()"
                            [readonly]="isEditModeComponent || !formControls.manualEntry.value"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.scCode.errors }" class="w-full"
                            formControlName="scCode" />
                        <div *ngIf="!isEditModeComponent" class="ml-2">
                            <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                                label="Manual Entry" value="true"></p-checkbox>
                        </div>
                    </div>
                </div>

                <!-- <div class="field text-left">2
                    <label for="website">SCNumber</label>
                    <div class="flex align-items-center">
                        <input pInputText placeholder="e.g P307" type="text" (blur)="checkSCNumber()"
                            [readonly]="!storeConsumptionLineitemForm.get('manualEntry2')?.value"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.scCode.errors }" class="w-full"
                            formControlName="serialNumber" />
                        <div *ngIf="!isEditModeComponent" class="ml-2">
                            <p-checkbox formControlName="manualEntry2" (onChange)="manualEntry2()" [binary]="true"
                                label="Manual Entry" value="true"></p-checkbox>
                        </div>
                    </div>
                </div> -->

                <div class="field text-left">
                    <label>From Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="fromDate"
                            styleClass="w-full" [showIcon]="true"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.fromDate.errors }"></p-calendar>
                    </div>
                </div>

                <div class="field text-left">
                    <label for="totLaborCost">Total Labor Cost</label>
                    <input pInputText class="w-full" formControlName="totLaborCost" type="number" readonly />
                    <small *ngIf="submitted && formControls.totLaborCost.errors" class="text-red-500">Required
                        field.</small>
                </div>

            </div>


            <div class="col">

                <div class="field text-left gap-3">
                    <label for="empName">Employee/Contractor Name</label>
                    <input pInputText class="w-full" formControlName="empName" />
                    <small *ngIf="submitted && formControls.empName.errors" class="text-red-500">Required field.</small>
                </div>

                <div class="field text-left">
                    <label>End Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="endDate"
                            styleClass="w-full" [showIcon]="true"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.endDate.errors }"></p-calendar>
                    </div>
                </div>


            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="laborRate">Labor Rate</label>
                    <input pInputText class="w-full" formControlName="laborRate" type="number" />
                    <small *ngIf="submitted && formControls.laborRate.errors" class="text-red-500">Required
                        field.</small>
                </div>

                <div class="field text-left gap-3">
                    <label for="totDays">Total Days</label>
                    <input pInputText class="w-full" formControlName="totDays" type="number" readonly />
                    <small *ngIf="submitted && formControls.totDays.errors" class="text-red-500">Required field.</small>
                </div>

            </div>

        </div>

        <div>
            <p-tabView>
                <p-tabPanel header="Components">
                    <div>
                        <div class="flex mb-1">
                            <p-button label="Add" class="p-button-outlined mr-3" size="small" severity="secondary"
                                (onClick)="addNewItem()"></p-button>
                            <p-button icon="pi pi-pencil" size="small" severity="secondary"
                                class="p-button-outlined mr-3" *ngIf="selectedProduct && selectedProduct.length === 1"
                                (onClick)="editItem()"></p-button>
                            <p-button severity="info" class="p-button-outlined mr-3" icon="pi pi-trash" size="small"
                                severity="secondary" severity="danger" (onClick)="deleteSClineItems()"
                                *ngIf="selectedProduct && selectedProduct.length > 0"></p-button>
                        </div>
                        <p-table #dt1 [value]="storeconsumptionData" [scrollable]="true" scrollHeight="350px"
                            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5"
                            styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
                            [(selection)]="selectedProduct" [globalFilterFields]="['productCode']"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [rowsPerPageOptions]="[10,15,20]">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th>Sr.No</th>
                                    <th>Product Code</th>
                                    <th>Opening Inventory</th>
                                    <th>Consumed Qty</th>
                                    <th>Closing Inventory</th>
                                    <th>Consumed In Operation</th>
                                    <th>Rate</th>
                                    <th>Total Cost</th>
                                    <th>Date</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-bomLineitem>
                                <tr>
                                    <td>
                                        <p-tableCheckbox [value]="bomLineitem"></p-tableCheckbox>
                                    </td>
                                    <td>{{bomLineitem.serialNumber}}</td>
                                    <td>{{bomLineitem.productCode}}</td>
                                    <td>{{bomLineitem.openingInventory}}</td>
                                    <td>{{bomLineitem.consumedQty}}</td>
                                    <td>{{bomLineitem.closingInventory}}</td>
                                    <td>{{bomLineitem.consumedInOperation}}</td>
                                    <td>{{bomLineitem.rate}}</td>
                                    <td>{{bomLineitem.totCost}}</td>
                                    <td>{{bomLineitem.date | date: 'dd/MM/yyyy'}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="3"></td>
                                    <td class="font-bold text-right">Total Qty:</td>
                                    <td class="font-bold">{{ totalConsumedQty }}</td>
                                    <td colspan="3" class="font-bold text-right">Total Cost:</td>
                                    <td class="font-bold">{{ totalCost }}</td>
                                    <td colspan="5"></td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="10">No data found.</td>
                                </tr>
                            </ng-template>

                        </p-table>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>

    </form>
</div>
<p-confirmDialog></p-confirmDialog>

<p-dialog [header]="isEditModesc ? 'Update Store Consumption Line Item' : 'Add Store Consumption Line Item'"
    [modal]="true" [(visible)]="visible" [style]="{ width: '90%' }" [draggable]="false" headerClass="'no-close-icon'">

    <div>
        <form [formGroup]="storeConsumptionLineitemForm">
            <div class="flex align-items-start pt20">
                <p-button [label]="isEditModesc ? 'Update' : 'Save'" class="p-button-outlined ml-2" icon="pi pi-save"
                    size="small" (click)="CreateStoreConsumptionLineitem(storeConsumptionLineitemForm.value)">
                </p-button>
                <div>
                    <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                        size="small" (click)="cancels(storeConsumptionLineitemForm.value)"></p-button>
                </div>
            </div>

            <div class="grid padd">
                <div class="col">
                    <div class="field text-left">
                        <label for="website">Serial Number</label>
                        <div class="flex align-items-center">
                            <input pInputText placeholder="e.g P307" type="text" (blur)="checkMONumber()"
                                [readonly]="isEditModesc || !formControl.manualEntry2.value" class="w-full"
                                formControlName="serialNumber" />
                            <div *ngIf="!isEditModesc" class="ml-2">
                                <p-checkbox formControlName="manualEntry2" (onChange)="manualEntry2()" [binary]="true"
                                    label="Manual Entry" value="true"></p-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="field text-left">
                        <label for="consumedInOperation" class="block">Consumed In Operation</label>
                        <textarea rows="1" pInputTextarea formControlName="consumedInOperation"
                            class="w-full"></textarea>
                    </div>

                    <div class="field text-left">
                        <label>Rate</label>
                        <input pInputText class="w-full" suffix=" units" type="number" formControlName="rate" />
                        <small *ngIf="submitted && formControl.rate.errors" class="text-red-500">Required field.</small>
                    </div>
                </div>

                <div class="col">
                    <div class="field text-left">
                        <label for="productCode" class="block">Products</label>
                        <p-autoComplete #productCodeAutoComplete formControlName="productCode"
                            placeholder="Search products" (onSelect)="setProducts($event)"
                            [suggestions]="nonInventryProductList"
                            (completeMethod)="autoSearchNonInventryProducts($event)" field="customerCode"
                            class="w-full">
                            <ng-template let-item pTemplate="item" class="w-full">
                                <span>{{item.productCode}} - {{item.productName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div>

                    <div class="field text-left">
                        <label for="consumedQty" class="block">Consumed Quantity</label>
                        <input pInputText class="w-full" formControlName="consumedQty" type="number" />
                        <small *ngIf="submitted && formControl.consumedQty.errors" class="text-red-500">Required
                            field.</small>
                    </div>
                    <div class="field text-left">
                        <label>Opening Inventory</label>
                        <input pInputText placeholder="0" type="number" min="0" formControlName="openingInventory"
                            class="w-full" />
                    </div>
                    <!-- <div class="field text-left">
                    <label for="description">Item Description</label>
                    <textarea rows="1" pInputTextarea formControlName="description" class="w-full"></textarea>
                  </div> -->

                </div>

                <div class="col">

                    <div class="field text-left">
                        <label for="totCost">Total Cost</label>
                        <input pInputText class="w-full" formControlName="totCost" type="number" readonly />
                        <small *ngIf="submitted && formControl.totCost.errors" class="text-red-500">Required
                            field.</small>
                    </div>

                    <div class="field text-left">
                        <label for="date">Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="date"
                                styleClass="w-full" [showIcon]="true" appendTo="body"></p-calendar>
                        </div>
                    </div>

                    <div class="field text-left">
                        <label for="closingInventory">Closing Inventory</label>
                        <input pInputText placeholder="0" type="number" min="0" formControlName="closingInventory"
                            class="w-full" />
                    </div>
                </div>
            </div>
        </form>
    </div>
</p-dialog>